.field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.label {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  color: var(--ink-soft);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.input {
  font-family: var(--font-body);
  font-size: var(--text-min-body);
  color: var(--ink);
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--radius-sharp);
  padding: 0.5rem 0.625rem;
}

.input:focus-visible {
  outline: 2px solid var(--cy-500);
  outline-offset: 1px;
}

.invalid {
  border-color: var(--stop);
}

.error {
  font-size: var(--text-min-mono);
  color: var(--stop);
  margin: 0;
}

/*
 * Optional help text under a field — `DES-001`. Added because the commercial-
 * rules screen carried its unit convention INSIDE the label ("MARGIN FLOOR
 * (FRACTION OF 1, E.G. 0.15 FOR 15%)") and `.label` uppercases, so a whole
 * explanatory sentence was being shouted in mono. A label names a field; a
 * hint explains it.
 */
.hint {
  font-size: var(--text-min-mono);
  color: var(--muted);
  margin: 0;
}
